import { UseQueryResult } from '@tanstack/react-query'

import { GetCurrentTaxYearUsePaymentsQuery, useGetCurrentTaxYearUsePaymentsQuery } from '../generated/graphql'
import useAuth from './useAuth'

export default function useGetCurrentTaxYearUsePayments(): UseQueryResult<GetCurrentTaxYearUsePaymentsQuery> {
  const { authInformation } = useAuth()

  return useGetCurrentTaxYearUsePaymentsQuery(
    {},
    {
      enabled: Boolean(authInformation && !authInformation.isMasterUser && !authInformation.isMcatUser),
      staleTime: Infinity, // The setting is fixed for the session; AuthProvider clears it on sign in / sign out
      gcTime: Infinity,
      retry: 2,
    },
  )
}

export function isPaymentsInUse(data?: GetCurrentTaxYearUsePaymentsQuery): boolean {
  return data?.currentTaxYearUsePayments.usePayments === true
}

export function useIsPaymentsDisabled(): boolean {
  const { data } = useGetCurrentTaxYearUsePayments()

  return !isPaymentsInUse(data)
}
